import { FormField } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useFormsTranslation } from '@/hooks/useTranslation';
import { memo } from 'react';
import { Control } from 'react-hook-form';
import { FormFieldWrapper } from '../../../FormFieldWrapper';
import { IdentificationFormData } from '../types';

interface BusinessActivitiesSectionProps {
  control: Control<IdentificationFormData>;
}

export function BusinessActivitiesSection({
  control,
}: BusinessActivitiesSectionProps) {
  const { t: tForms } = useFormsTranslation();

  return (
    <div className='space-y-6'>
      <div className='flex items-center gap-2 mb-4'>
        <h4 className='text-md font-medium'>
          {tForms('identification.sections.businessActivities')}
        </h4>
      </div>

      {/* Row 1: Number of Employees */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-start'>
        <FormField
          control={control}
          name='employees'
          render={({ field, fieldState }) => (
            <FormFieldWrapper
              label={tForms('identification.fields.employees')}
              name='employees'
              required
              tooltip={tForms('identification.tooltips.employees')}
              error={fieldState.error?.message}
            >
              <Input
                {...field}
                type='number'
                placeholder={tForms('identification.placeholders.employees')}
                className='min-h-[44px]'
                min='0'
              />
            </FormFieldWrapper>
          )}
        />
        {/* Empty space for alignment */}
        <div></div>
      </div>

      {/* Business Description */}
      <FormField
        control={control}
        name='businessDescription'
        render={({ field, fieldState }) => (
          <FormFieldWrapper
            label={tForms('identification.fields.businessDescription')}
            name='businessDescription'
            required
            tooltip={tForms('identification.tooltips.businessDescription')}
            error={fieldState.error?.message}
          >
            <Textarea
              {...field}
              placeholder={tForms(
                'identification.placeholders.businessDescription'
              )}
              className='min-h-[100px] resize-vertical'
              rows={4}
            />
          </FormFieldWrapper>
        )}
      />
    </div>
  );
}

// Memoize component to prevent unnecessary re-renders
export default memo(BusinessActivitiesSection);
